import { Image } from '@silvertours/common-landingpages-view';
import { MediaLegacy } from '@silvertours/front-legacy-shared';
import { useCallback, useState } from 'react';
import { SearchForm } from '../SearchForm';
import {
  BackgroundImage,
  MobileSearchContainer,
  SearchFormContainer,
} from './NewSearch.styles';
import { StageContentContainer } from './Stage.styles';
import { SearchWizard } from '../SearchWizard';
import { matchError, useSubmitHandler } from '../SearchFormLegacy';
import { useSearchContext } from '../SearchFormLegacy/context';
import { isFormError } from '../SearchFormLegacy/context/types';

type Props = {
  image: MediaLegacy.ImageProps | Image;
};

const NewSearchContainer = ({ image }: Props) => {
  const [showWizard, setShowWizard] = useState(false);

  const action = () => {
    setShowWizard(true);
  };

  const { state, setError } = useSearchContext();
  const submitHandler = useSubmitHandler();

  const onError = useCallback((error: any) => {
    console.error(error);

    const { type: kind, message } = matchError(error);

    if (isFormError(kind)) {
      setError({ kind, message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (showWizard) {
    return (
      <SearchWizard
        onClose={() => setShowWizard(false)}
        onConfirm={() => {
          submitHandler(state, '', () => {}, onError);
        }}
      />
    );
  }

  return (
    <MobileSearchContainer>
      <BackgroundImage
        {...image}
        id="stage-image-mobile"
        fill
        priority
        style={{
          objectFit: 'cover',
        }}
      />
      <StageContentContainer>
        <SearchFormContainer>
          <SearchForm searchAction={action} />
        </SearchFormContainer>
      </StageContentContainer>
    </MobileSearchContainer>
  );
};

export { NewSearchContainer };
